import { Typography } from "@/components/ui/typography";
import { cn } from "@/lib/utils";
import Image, { StaticImageData } from "next/image";
import { memo } from "react";

export type ServiceResourceCardProps = {
  title: string;
  description: string;
  imageUrl: string | StaticImageData;
} & React.ComponentProps<"div">;

const ServiceResourceCard = ({
  title,
  imageUrl,
  description,
  className,
}: ServiceResourceCardProps) => {
  return (
    <div
      className={cn(
        "flex flex-col border bg-white border-neutral-200 rounded-3xl overflow-hidden lg:rounded-2xl lg:border-0",

        className
      )}
    >
      <div className="flex relative overflow-hidden rounded-3xl lg:mt-5 lg:mx-5 lg:rounded-[8px] shrink-0 aspect-[1/0.69] lg:aspect-[1/0.61]">
        <Image
          alt={title}
          src={imageUrl}
          fill
          className="w-full h-full flex-auto min-w-0"
          objectFit="cover"
        />
      </div>
      <div className="flex flex-col p-5 min-w-0 flex-auto lg:pt-3">
        <div className="grid grid-cols-1 gap-3 place-content-start flex-auto">
          <Typography
            variant="titleMd"
            asChild
            className="font-medium text-semantic-text-primary lg:font-semibold lg:leading-[150%] lg:text-gray-800"
          >
            <h4>{title}</h4>
          </Typography>
          {!!description && (
            <Typography
              variant="labelMd"
              asChild
              className="text-semantic-text-primary line-clamp-3 md:line-clamp-none leading-[160%] lg:text-sm lg:leading-[150%] lg:text-gray-600"
            >
              <p>{description}</p>
            </Typography>
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(ServiceResourceCard);
